import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private _router: Router) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        console.log('HttpErrorInterceptor error', error);

        let message: string =
          !!error.error && !!error.error.message ? error.error.message : null;

        if (error.status === 500 && message === 'Unauthenticated.') {
          Swal.fire({
            title: `Error`,
            html: `Su sesión ha expirado. Favor ingrese nuevamente.`,
            icon: `error`,
          });

          this._router.navigate(['/login']);
        }

        return throwError(() => error);
      })
    );
  }
}
